import { ReplyOrder, ReplyOrderText } from '@diritto/common/reply/constants';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Divider } from 'ui-components/common/Divider';
import React, { useCallback } from 'react';

interface ReplyTabProps {
  className?: string;
  replyCount: number;
  orderBy: ReplyOrder;
  orderList?: ReplyOrder[];
  onChange?: (key: ReplyOrder) => void;
}

export const ReplyTab = ({
  className,
  replyCount,
  orderBy,
  orderList = [ReplyOrder.Latest, ReplyOrder.Like],
  onChange,
}: ReplyTabProps) => {
  const handleChangeOrderBy = useCallback(
    (key: ReplyOrder) => {
      onChange?.(key);
    },
    [onChange],
  );

  return (
    <StyledTabMenu className={className}>
      <p>댓글{replyCount > 0 && <span> {replyCount}</span>}</p>
      <StyledTabButtons>
        {orderList.map(order => (
          <StyledTabButton
            key={order}
            type="button"
            isSelected={orderBy === order}
            onClick={() => handleChangeOrderBy(order)}>
            {ReplyOrderText[order]}
          </StyledTabButton>
        ))}
      </StyledTabButtons>
      <Divider position="bottom" color={Color.Gray200} />
    </StyledTabMenu>
  );
};

const StyledTabMenu = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;

  & > p {
    font-weight: ${FontWeight.Bold};
    & > span {
      font-weight: ${FontWeight.Regular};
    }
  }
`;

const StyledTabButton = styled.button(
  ({ isSelected }: { isSelected: boolean }) => css`
    font-weight: ${isSelected ? FontWeight.Bold : FontWeight.Medium};
    ${Typography.XXSmall};
  `,
);

const StyledTabButtons = styled.div`
  ${StyledTabButton} + ${StyledTabButton} {
    margin-left: 10px;
  }
`;
